import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.osanoScriptUrl && environment.osanoScriptUrl.length > 0) {
    const script: HTMLScriptElement = document.createElement('script');
    script.src = environment.osanoScriptUrl;
    const firstHeaderElement: ChildNode = document.head.firstChild;
    document.head.insertBefore(script, firstHeaderElement); // ensure script is right at the top
}

export function getBaseUrl() : string {
    return document.getElementsByTagName('base')[0].href;
}

const providers : any = [
    { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
    .catch((err : any) => console.error(err));
